const setAttributesToElement = (el, attrs) => {
  for (const key in attrs) {
    // eslint-disable-next-line no-prototype-builtins
    if (attrs.hasOwnProperty(key)) {
      const value = attrs[key];
      el.setAttribute(key, value);
    }
  }
};

const addLink = (href, attrs) => {
  const el = document.createElement('link');
  Object.assign(el, { rel: 'stylesheet', href });
  setAttributesToElement(el, attrs);
  document.head.appendChild(el);
  return el;
};

const generateSelectorAttributes = (attrs) =>
  Object.entries(attrs).reduce((acc, [key, value]) => acc + `[${key}="${value}"]`, '');

const groupByAddRemove = (links, urls) => {
  const toRemove = [];
  const toAdd = [...urls];

  for (let i = links.length - 1; i >= 0; i--) {
    const link = links[i];
    const urlIdx = toAdd.indexOf(link.href);
    if (urlIdx === -1) {
      toRemove.push(link);
    } else {
      toAdd.splice(urlIdx, 1);
    }
  }

  return { toAdd, toRemove };
};

const recycleLinks = (toAdd, toRemove) => {
  const minLength = toAdd.length < toRemove.length ? toAdd.length : toRemove.length;

  for (let i = 0; i < minLength; i++) {
    const link = toRemove[i];
    link.href = toAdd[i];
  }

  const toCreate = toAdd.slice(minLength);
  const toDelete = toRemove.slice(minLength);

  return { toCreate, toDelete };
};

export const createStylesheetsFromUrls = (urls = []) => {
  const attrs = { 'cld-dynamic-stylesheet': 'cld' };
  const { document } = global;
  if (!document) {
    return;
  }

  const links = document.querySelectorAll(`link[rel="stylesheet"]${generateSelectorAttributes(attrs)}`);

  const { toAdd, toRemove } = groupByAddRemove(links, urls);
  const { toCreate, toDelete } = recycleLinks(toAdd, toRemove);

  toCreate.forEach((url) => addLink(url, attrs));
  toDelete.forEach((link) => link.parentElement.removeChild(link));
};
